import { Store } from '@ngrx/store';
import { Component, signal, Output, EventEmitter, input, model, WritableSignal, Input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KENDO_COMBOBOX } from "@progress/kendo-angular-dropdowns";
import { ControlsModule } from '@pmis3/ui-controls';
import { KENDO_DIALOGS } from '@progress/kendo-angular-dialog';
import { IOrganization, IOrganizationTypeOrganization, IOrganizationType, IOrganizationEdit } from '@pmis3/master-data-core';
import { IconsModule } from '@progress/kendo-angular-icons';
import { KENDO_BUTTONS } from "@progress/kendo-angular-buttons";
import { selectOrganizations, selectOrganizationTypes } from '@pmis3/vessel-activity-core';

@Component({
    selector: 'pmis3-vessel-visit-detail-organization-picker',
    standalone: true,
    imports: [CommonModule, ControlsModule, KENDO_COMBOBOX, KENDO_DIALOGS, KENDO_BUTTONS, IconsModule],
    templateUrl: 'vessel-visit-detail-organization-picker.component.html',
    styleUrl: "vessel-visit-detail-organization-picker.component.css"
})
export class VesselVisitDetailOrganizationPickerComponent {
    @Output() assignedOrganization = new EventEmitter<IOrganizationEdit>();

    @Input({ required: true }) showDialog!: WritableSignal<boolean>;
    disabled = input<boolean>(false);

    organizations = this.store.selectSignal(selectOrganizations);
    organization = signal<IOrganization | undefined>(undefined);
    organizationTypeId = signal<number | undefined>(undefined);

    allOrganizationTypes = this.store.selectSignal(selectOrganizationTypes);
    organizationTypesOfSelectedOrganization = computed(() => {
        const organizationTypeIds = this.organization()?.organizationTypeIds ?? [];
        const allOrganizationTypes = this.allOrganizationTypes()
        if (organizationTypeIds && allOrganizationTypes) {
            const result = organizationTypeIds.flatMap(id => {
                const match = allOrganizationTypes.find(orgType => orgType.organizationTypeId == id);
                return match ? [match] : [];
            });
            return result;
        }
        return [];
    })

    assignIsDisabled = computed(() => !this.organization() || !this.organizationTypeId())

    toggleShowDialog() {
        this.showDialog.update(show => !show);
    }

    assignOrganizationAndType() {
        const organization = this.organization();
        const organizationTypeId = this.organizationTypeId();

        if (organization && organizationTypeId) {
            const newOrganization = {
                id: 0,
                organizationId: organization.id,
                organizationTypeId: organizationTypeId,
                isAdded: true
            } as IOrganizationEdit;

            this.assignedOrganization.emit(newOrganization);
        }
        
        this.close();
    }

    close() {
        this.resetDropdowns()
        this.toggleShowDialog();
    }

    resetDropdowns() {
        this.organization.set(undefined);
        this.organizationTypeId.set(undefined);
    }

    constructor(private store: Store<any>) {
    }
}